import EventTracker from 'eventTracker'
import EventTypes from 'constants/EventTypes'
import {gql} from "@apollo/client";

export function addAI(aId, aName, aKeyword, aDescription){
  if(aId){
    EventTracker.track(EventTypes.UPDATE_AI);
  }
  else{
    EventTracker.track(EventTypes.CREATE_AI);
  }
  let query = `
    mutation SaveAiModelMutation ($saveAiModelMutationInput: SaveAiModelMutationInput!) {
      saveAiModelMutation (input: $saveAiModelMutationInput){
        ai_model {
          id
          name
          keyword
          created_at
          updated_at
          description
          documents {
            id
            name
            file_url
            created_at
            updated_at
            embedding_generated
          }
        }
      }
    }
  `;
  let params = {};
  let operationName = `SaveAiModelMutation`;
  
  return (dispatch, getState) => {
    let state = getState();
    params['company_id'] = state.company && state.company.company && state.company.company.id;
    
    if(aId){
      params['id'] = aId;
    }
    params['name'] = aName;
    params['keyword'] = aKeyword;
    params['description'] = aDescription;
    
    let variables = {
      saveAiModelMutationInput:params
    };
    return global.api.post("/queries", {query, variables, operationName});
  };
}

export function addAIDocument(aId, aAiId, aName, aFile, aClient){
  if(aId){
    EventTracker.track(EventTypes.UPDATE_AI_DOCUMENT);
  }
  else{
    EventTracker.track(EventTypes.CREATE_AI_DOCUMENT);
  }
  let graphQLQuery =
    gql`mutation SaveAiDocumentMutation ($saveAiDocumentMutationInput: SaveAiDocumentMutationInput!) {
        saveAiDocumentMutation (input: $saveAiDocumentMutationInput){
          ai_document {
            id
            name
            file_url
            embedding_generated
            created_at
            updated_at
          }
        }
      }
   `;
  
  return (dispatch, getState) => {
    let state = getState();
    
    let variables = {
      saveAiDocumentMutationInput: {
        company_id:state.company && state.company.company && state.company.company.id,
        id:aId,
        ai_model_id:aAiId,
        name:aName,
        file:aFile
      }
    };
    return aClient
    .mutate({
      mutation:graphQLQuery,
      variables:variables,
      context:{ hasUpload:true }
    });
  };
}

export function addAIMessage(aKeyword, aMessage, aPatientId, aFile, aClient){
  EventTracker.track(EventTypes.ADD_AI_MESSAGE);
  let graphQLQuery =
    gql`mutation AskAiQuestionMutation ($askAiQuestionMutationInput: AskAiQuestionMutationInput!) {
      askAiQuestionMutation (input: $askAiQuestionMutationInput){
        ask_ai_response {
          question_message {
            id
            message_text
            created_at
            updated_at
            is_ai_response
          }
          response_message {
            id
            message_text
            created_at
            updated_at
            is_ai_response
          }
        }
      }
    }
  `;
  let params = {};
  
  return (dispatch, getState) => {
    let state = getState();
    params['company_id'] = state.company && state.company.company && state.company.company.id;
    params['message_text'] = aMessage;
    params['ai_model_keyword'] = aKeyword;
    
    if(aPatientId){
      params['patient_id'] = aPatientId;
    }
    if(aFile){
      params['message_audio_file'] = aFile;
    }
    let variables = {
      askAiQuestionMutationInput:params
    };
    return aClient
    .mutate({
      mutation:graphQLQuery,
      variables:variables,
      context:{hasUpload:true}
    });
  };
}

export function fetchAI(aId){
  EventTracker.track(EventTypes.FETCH_AI);
  let query = `
    query getAiModel ($company_id: ID!, $ai_model_id: ID!) {
      ai_model (company_id: $company_id, ai_model_id: $ai_model_id){
        id
        name
        keyword
        created_at
        updated_at
        description
        documents {
          id
          name
          file_url
          created_at
          updated_at
          embedding_generated
        }
      }
    }
  `;
  let variables = {};
  
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['ai_model_id'] = aId;
    return global.api.post("/queries", { query, variables })
  };
}

export function fetchAIs(aLimit, aOffset, aSearchString){
  EventTracker.track(EventTypes.FETCH_AIS);
  let query = `
    query getAiModels ($company_id: ID!, $limit: Int, $offset: Int, $search_string: String) {
      ai_models (company_id: $company_id, limit: $limit, offset: $offset, search_string: $search_string){
        ai_models {
          id
          name
          keyword
          created_at
          updated_at
          description
        }
        total
      }
    }
  `;
  let variables = {};
  
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['limit'] = aLimit;
    variables['offset'] = aOffset;
    
    if(aSearchString){
      variables['search_string'] = aSearchString;
    }
    return global.api.post("/queries", { query, variables })
  };
}

// TODO: Right now, this isn't implemented, as the documents are sent with the AI_Model.
export function fetchAIDocuments(aId, aLimit, aOffset, aSearchString){
  EventTracker.track(EventTypes.FETCH_AI_DOCUMENTS);
  let query = `
    query getAiModels ($company_id: ID!, $limit: Int, $offset: Int, $search_string: String) {
      ai_models (company_id: $company_id, limit: $limit, offset: $offset, search_string: $search_string){
        ai_models {
          id
          name
          keyword
          created_at
          updated_at
        }
        total
      }
    }
  `;
  let variables = {};
  
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['ai_model_id'] = aId;
    variables['limit'] = aLimit;
    variables['offset'] = aOffset;
    
    if(aSearchString){
      variables['search_string'] = aSearchString;
    }
    return global.api.post("/queries", { query, variables })
  };
}

export function fetchAIMessages(aKeyword, aPatientId, aLimit, aOffset, aSearchString){
  EventTracker.track(EventTypes.FETCH_AI_MESSAGES);
  let query = `
    query getAiMessages ($company_id: ID!, $patient_id: ID, $ai_model_keyword: String!, $limit: Int, $offset: Int) {
      ai_messages (company_id: $company_id, patient_id: $patient_id, ai_model_keyword: $ai_model_keyword, limit: $limit, offset: $offset){
        ai_messages {
          question_message {
            id
            created_at
            updated_at
            message_text
            is_ai_response
          }
          response_message {
            id
            created_at
            updated_at
            message_text
            is_ai_response
          }
        }
        total
      }
    }
  `;
  let variables = {};
  
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['ai_model_keyword'] = aKeyword;
    variables['limit'] = aLimit;
    variables['offset'] = aOffset;
    
    if(aPatientId){
      variables['patient_id'] = aPatientId;
    }
    if(aSearchString){
      variables['search_string'] = aSearchString;
    }
    return global.api.post("/queries", { query, variables })
  };
}

export function removeAI(aId){
  EventTracker.track(EventTypes.REMOVE_AI);
  let query = `
    mutation RemoveAiModelMutation($removeAiModelMutationInput: RemoveAiModelMutationInput!) {
      removeAiModelMutation(input: $removeAiModelMutationInput) {
        ai_model {
          id
        }
      }
    }
  `;
  let params = {};
  let operationName = `RemoveAiModelMutation`;
  
  return (dispatch, getState) => {
    let state = getState();
    params['company_id'] = state.company && state.company.company && state.company.company.id;
    params['ai_model_id'] = aId;
    
    let variables = {
      removeAiModelMutationInput:params
    };
    return global.api.post("/queries", {query, variables, operationName});
  };
}

export function removeAIDocument(aId){
  EventTracker.track(EventTypes.REMOVE_AI_DOCUMENT);
  let query = `
    mutation RemoveAiDocumentMutation($removeAiDocumentMutationInput: RemoveAiDocumentMutationInput!) {
      removeAiDocumentMutation(input: $removeAiDocumentMutationInput) {
        ai_document {
          id
        }
      }
    }
  `;
  let params = {};
  let operationName = `RemoveAiDocumentMutation`;
  
  return (dispatch, getState) => {
    let state = getState();
    params['company_id'] = state.company && state.company.company && state.company.company.id;
    params['ai_document_id'] = aId;
    
    let variables = {
      removeAiDocumentMutationInput:params
    };
    return global.api.post("/queries", {query, variables, operationName});
  };
}
